import api from './api';

const LessonPlanService = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/lesson-plans/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching lesson plans:', error);
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/lesson-plans/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching lesson plan:', error);
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await api.post('/lesson-plans/', data);
      return response.data;
    } catch (error) {
      console.error('Error creating lesson plan:', error);
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`/lesson-plans/${id}/`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating lesson plan:', error);
      throw error;
    }
  },

  partialUpdate: async (id, data) => {
    try {
      const response = await api.patch(`/lesson-plans/${id}/`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating lesson plan:', error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/lesson-plans/${id}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting lesson plan:', error);
      throw error;
    }
  },

  // Criar plano de aula com competências e habilidades em lote
  batchCreate: async (data) => {
    try {
      const response = await api.post('/lesson-plans/batch-create/', data);
      return response.data;
    } catch (error) {
      console.error('Error batch creating lesson plan:', error);
      throw error;
    }
  },

  // Obter progresso do plano de aula com estatísticas
  getProgress: async (id) => {
    try {
      const response = await api.get(`/lesson-plans/${id}/progress/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching lesson plan progress:', error);
      throw error;
    }
  },

  // Converter arquivo para base64
  fileToBase64: (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }
};

export default LessonPlanService;
